'use strict';

import ngRoute from 'angular-route';
import angular from 'angular';
import {CarritoRouteComponent} from './carrito-route.component.js';
import CarritoService from './carrito-route.service.js';

/*@ngInject*/
const routes = function ($routeProvider) {
    $routeProvider.when('/carrito', {
        template: '<carrito-route></carrito-route>',
        authenticate: true
    })
};

export default angular.module('pizzutoAutopartesApp.carrito', [ngRoute])
    .config(routes)
    .component(CarritoRouteComponent.selector, CarritoRouteComponent)
    .service('CarritoService', CarritoService)
    .name;



// WEBPACK FOOTER //
// ./client/app/carrito-route/index.js